var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkoOp2Yellow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 87,
    viewBox: "0 0 100 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OKO_op2_yellow2",
    clipPath: "url(#clip0_525_856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.5558 0.0502482C76.828 -1.25334 101.805 22.253 99.8998 51.968C97.8775 83.5298 65.7559 88.5436 40.1521 86.3626C-23.0049 80.9978 -4.83827 2.38166 47.5558 0.0502482Z",
    fill: "#F6F416"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.5387 34.3026C59.5387 28.3696 65.0038 23.5647 71.7473 23.5647C78.4908 23.5647 83.9559 28.3696 83.9559 34.3026",
    fill: "#002E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M66.3658 34.3026C66.3658 31.7456 68.7808 29.6565 71.7557 29.6565C74.7305 29.6565 77.1455 31.7456 77.1455 35.3026",
    fill: "#F6F416"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.0663 35.0047C18.0663 29.0717 23.5314 24.2668 30.2749 24.2668C37.0185 24.2668 42.4835 29.0717 42.4835 35.0047",
    fill: "#002E19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.8935 35.0048C24.8935 32.4477 27.3084 30.3586 30.2833 30.3586C33.2581 30.3586 35.6731 32.4477 35.6731 36.0048",
    fill: "#F6F416"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 86.8054,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkoOp2Yellow2);
export default __webpack_public_path__ + "static/media/OKO_op2_yellow2.5ae6910850fd1aba5274bdaeb73468a1.svg";
export { ForwardRef as ReactComponent };